// Images
import eFerry from "../assets/images/circle-e-ferry.png";
import transport from "../assets/images/circle-transport.png";
import datacenter from "../assets/images/circle-datacenter.png";
import ocean from "../assets/images/ocean-circle.png";
import aviation from "../assets/images/aviation-circle.png";
import solar from "../assets/images/solar-circle.png";
import emobility from "../assets/images/emobility-circle.png";
import steel from "../assets/images/steel-circle.png";
import snowmobile from "../assets/images/snowmobile-circle.png";

type location = {
    position: google.maps.LatLng | google.maps.LatLngLiteral;
    text: string;
    image: string;
};

export const locationsSwedish: location[] = [
    {
        position: { lat: 63.646, lng: 17.38 }, // Västerbotten
        text: "Fossilfritt stål",
        image: steel,
    },
    {
        position: { lat: 58.77690182569799, lng: 1.28734342841301 }, // ocean
        text: "Kraft från havet",
        image: ocean,
    },
    {
        position: { lat: 52.369111327037935, lng: 4.897435768386662 }, // Amsterdam
        text: "Fossilfritt flygbränsle",
        image: aviation,
    },
    {
        position: { lat: 62.85812976904402, lng: 26.317125519118118 }, // Finland
        text: "Växande solkraft",
        image: solar,
    },
    {
        position: { lat: 60.30125306521807, lng: 13.856439718200733 }, // sweden
        text: "Fler laddstationer",
        image: emobility,
    },
    {
        position: { lat: 65.46001284946631, lng: 27.45821843999175 }, // finland
        text: "Eldrivna snöskotrar",
        image: snowmobile,
    },
    {
        position: { lat: 57.47041188776262, lng: 18.485209857731583 }, // gotland
        text: "Trådlösa elvägar",
        image: transport,
    },
    {
        position: { lat: 65.4055366973776, lng: 21.420009695657612 },
        text: "Fossilfria datacenter",
        image: datacenter,
    },
    {
        position: { lat: 59.007, lng: 17.622 }, // Stockholm
        text: "Eldriven sjötrafik",
        image: eFerry,
    },
];